// src/components/guide/GuideBar.tsx
//
// The guide bar is retired (Horizons talk-first, 2026-10-14): planning is a
// conversation now, not a guided path of pages. Today still marks the spot
// where the bar used to open; the anchor draws nothing.
export function GuideAnchor() {
  return null
}
